var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "close-ico-a",
    d: "M10.023 8.962l4.243-4.242a.75.75 0 111.06 1.06l-4.242 4.243 4.242 4.243a.75.75 0 11-1.06 1.06l-4.243-4.242-4.243 4.242a.75.75 0 11-1.06-1.06l4.242-4.243L4.72 5.78a.75.75 0 011.06-1.06l4.243 4.242z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "close-ico-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close-ico-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#close-ico-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    mask: "url(#close-ico-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-5h30v30H-5z"
  })))));
};
export default SvgClose;